/**
 * Link tools.
 */
H_Tools.links = (() => {
    // console.log('Link tools initialized');

    function addAriaCurrent(el) {
        // console.log('Adding aria-current attributes...');

        const current = window.location.origin + window.location.pathname;

        el.querySelectorAll('a[href]').forEach((link) => {
            if (link.href === current) {
                link.setAttribute('aria-current', 'true');
            }
        });
    }

    /**
     * Add the supplied text to the title attribute of the supplied element.
     *
     * The elements previous title attribute is preserved and this new text is appended to the end
     * of the previous description.
     *
     * @param el   An element
     * @param text The text to append to the element's title attribute
     */
    function append_title_attribute(el, text) {
        let old = el.getAttribute('title');
        el.setAttribute('title', old ? old + ', ' + text.toLowerCase() : text);
    }

    /**
     * Modify all links inside the supplied element to include title attributes for screen readers
     * when the link opens in a new window and when the link leads to a different site.
     *
     * Representative modifier classes are also added for in these cases.
     *
     * @param {*} el The element to process
     */
    function modifyLinks(el) {
        el.querySelectorAll('a[href]').forEach((link) => {
            // console.log('link', link);

            if (
                link.href.startsWith('sms:') ||
                link.href.startsWith('tel:') ||
                link.href.startsWith('mailto:') ||
                link.href.startsWith('javascript:') // jshint ignore:line
            ) {
                return;
            }

            // Anchor links
            if (
                link.href.startsWith('#') ||
                link.href.startsWith(window.location.href.split('#')[0] + '#')
            ) {
                link.classList.add('-same-page-anchor');
                append_title_attribute(link, link_descriptions.anchor);
            }

            // Links that open in a new tab
            if (link.target === '_blank') {
                link.classList.add('-opens-in-new-tab');
                append_title_attribute(link, link_descriptions.new_tab);
            }

            // External links
            if (link.hostname !== window.location.hostname) {
                link.classList.add('-external');
                append_title_attribute(link, link_descriptions.external);
            }
        });
    }

    // return an object to expose inner functions
    return {
        addAriaCurrent: addAriaCurrent,
        modifyLinks: modifyLinks,
    };
})();
